import PropTypes from "prop-types"

const paymentMethodPropType = PropTypes.oneOf(["credit_card", "direct_debit", "paypal", "wallet"])

export default paymentMethodPropType
